<template>
  <!-- 对接详情 -->
  <div class="DockingDetailsCenterRightContent">

    <div class="DockingDetailsCenterRightHead meet-title">
      <el-row class="content">
        <el-col class="contentLeft" :xs="24" :sm="18">
          <div class="title">
            {{msg.title}}
          </div>
          <div class="tags">
            <div class="tag" v-for="(item,index) in tagsList" :key="index">
              {{item}}
            </div>
          </div>
        </el-col>
        <el-col class="contentRight" :xs="24" :sm="6">
          <div class="contentRightHot">
            <img src="../../../../public/static/images/hot.png" alt="">
            <span>人气值</span>
            <span>5633</span>
          </div>
          <div class="contentRightButton">
            <div class="button">立即报名</div>

          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 锚点指示 -->
    <div class="head">
      <div class="main nav">
        <div class="nav_div" v-for="(item,index) in navList" :key="index" :class="index==0?'nav_div_active':''">{{item}}
        </div>
      </div>
    </div>


    <!-- 参会企业介绍 -->

    <div class="DockingDetailsCenterRightBottom ">
      <el-row v-for="(item,index) in project" :key="index">
        <el-col :xs="0" :sm="2" class="hidden-only-xs opacity-0">.</el-col>
        <el-col :xs="24" :sm="20">
          <div class="content">
            <div class="contentLi">
              <div class="title">
                <span>{{index + 1}}.</span>
                <span>{{item.title}}</span>
              </div>
              <div class="msg">
                <!-- 简介 -->
                <div class="synopsis">
                  {{item.introduce}}
                </div>
                <div class="text">
                  {{item.service}}
                </div>
              </div>
              <div class="button">
                <div class="buttonDiv">了解项目</div>
                <div class="buttonDiv">预览BP</div>
              </div>
            </div>

          </div>
        </el-col>
        <el-col :xs="0" :sm="2" class="hidden-only-xs opacity-0">.</el-col>
      </el-row>


    </div>




  </div>
</template>

<script>
  export default {
    props: {
      msg: Object
    },
    components: {
    },
    data() {
      return {
        tagsList: [],
        navList: ['项目介绍', '交流区'],
        project: [],//参会项目
      }
    },
    created: function () {

    },
    watch: {

      msg(val) {
        console.log('会议详情页面', val);
        this.tagsList = val.tag.split(',');
        this.project = val.project[0];
        console.log('this.project',this.project);
      }
    },
    methods: {},

  }
</script>

<style scoped>
  @media (max-width: 768px) {

    /* .div{
    margin-left: 10px;
    margin-right: 10px;
  } */
    .DockingDetailsCenterRightContent {
      margin-left: 0 !important;
    }
  }

  .DockingDetailsCenterRightContent {
    background-color: #1d1d1f;
    border-radius: 25px;
    margin-left: 7px;
  }

  /* 项目介绍-交流区导航 */

  @media (max-width: 768px) {
    .head .nav {
      margin: 0 15px;
    }
  }

  .head {
    background-color: #2c2c2c;
  }

  .nav {
    display: flex;
    justify-content: left;
    margin: 0 42px;
  }

  .nav_div {
    padding: 25px 0;
    margin-right: 40px;

    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #999999;
    position: relative;
  }

  .nav_div_active {
    color: #ffffff;
  }

  .nav_div_active::after {
    content: '';
    position: absolute;
    bottom: 1px;
    left: 25%;
    display: block;
    width: 41px;
    height: 5px;
    background-color: #00fefe;
    border-radius: 2px;

  }


  @media (max-width: 768px) {

    /* .div{
    margin-left: 10px;
    margin-right: 10px;
  } */
    .DockingDetailsCenterRightBottom .content {
      margin-left: 15px;
      margin-right: 15px;
    }

    .DockingDetailsCenterRightBottom .contentLi {
      padding: 25px 0;
    }

    .DockingDetailsCenterRightBottom .button {
      display: flex;
      justify-content: space-around;
      margin-top: 20px;
    }

    .DockingDetailsCenterRightBottom .msg {
      margin-left: 15px;
      margin-top: 20px;
    }

  }

  /* 内容详情 */

  .content {
    margin-left: 49px;
    margin-right: 32px;
  }

  .contentLi {
    padding: 45px 0;
    border-bottom: 1px solid #dcdcdc;
  }

  .content>.contentLi:last-child {
    border-bottom: none;
  }

  .title>span:first-child {

    font-size: 24px;
    font-weight: normal;
    font-style: italic;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #fff;
  }

  .title>span:last-child {
    margin-left: 13px;

    font-size: 24px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #fff;
  }

  .msg {
    margin-left: 29px;
    margin-top: 28px;
  }

  .synopsis {

    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 29px;
    letter-spacing: 0px;
    color: #dcdcdc;
  }

  .text {
    margin-top: 20px;

    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 29px;
    letter-spacing: 0px;
    color: #dcdcdc;
  }

  .button {
    margin-left: 29px;
    margin-top: 31px;
    display: flex;
    justify-content: left;
  }

  .buttonDiv {
    padding: 3px 20px;
    border-radius: 17px;
    border: solid 1px #dcdcdc;

    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 28px;
    letter-spacing: 0px;
    color: #dcdcdc;
    margin-right: 24px;
  }

  /* 会议标题部分 meet-title */

  @media (max-width: 768px) {

    /* .div{
    margin-left: 10px;
    margin-right: 10px;
  } */
    .DockingDetailsCenterRightHead .content {
      margin: 0 15px
    }

    .DockingDetailsCenterRightHead .contentRight {
      margin-top: 20px;
    }
  }

  .meet-title .content {
    margin: 0 32px 0 32px;
    padding: 36px 0 20px 0;
  }

  .meet-title .title {

    font-size: 32px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #ffffff;
  }

  .meet-title .tags {
    display: flex;
    justify-content: left;
    margin-top: 18px;
  }

  .meet-title .tag {
    border-radius: 5px;
    border: solid 1px #8E8E91;

    font-size: 15px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 28px;
    letter-spacing: 0px;
    color: #8E8E91;
    padding: 0px 19px;
    margin-right: 16px;
  }

  .meet-title .contentRightHot {
    text-align: right;
    color: #ffffff;
  }

  .meet-title .contentRightHot>span {
    margin-left: 5px;
  }

  .meet-title .contentRightButton {
    text-align: right;
    margin-top: 24px;
  }

  .meet-title .button {
    padding: 9px 29px;
    margin-left: 0px;
    margin-right: 0px;
    font-size: 16px;
    letter-spacing: 0px;
    color: #e6e6e9;
    border-radius: 20px;
    border: solid 1px #cecece;
    display: inline-block;
  }
</style>